import { LocaleMessages, VueMessageType } from "vue-i18n"

export function loadLocaleMessages (): {[locale: string]:LocaleMessages<VueMessageType>} {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages: {[locale: string]:LocaleMessages<VueMessageType>} = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })

  return messages
}
